import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Storefront-optimized defaults
      staleTime: 5 * 60 * 1000, // 5 minutes - products don't change often
      gcTime: 10 * 60 * 1000, // 10 minutes cache time (formerly cacheTime)
      refetchOnWindowFocus: false, // Don't refetch when user returns to tab
      retry: 1, // Only retry failed requests once
      refetchOnMount: true, // Refetch on component mount
    },
    mutations: {
      retry: 0, // Don't retry mutations (cart updates, reservations)
    },
  },
});
